<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <icon-approval-doc />
        휴일근무사전대체 취소신청
      </v-col>
    </v-row>

    <div class="apply-list px-6 overflow-y-auto">
      <v-text-field
        label="근무구분"
        v-model="replaceGubun"
        readonly
      ></v-text-field>
      <v-text-field
        label="휴일 근무일자"
        v-model="workYmd"
        readonly
      ></v-text-field>
      <v-text-field label="휴일 업무내용" v-model="note"></v-text-field>
      <div v-show="vShow">
        <v-text-field
          class="bottom--box"
          label="시업시간(휴일)"
          v-model="reqTime"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="추가휴게(휴일)"
          v-model="addRestTime"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="실 근무시간"
          v-model="reqHm"
          readonly
        ></v-text-field>
      </div>
      <v-text-field
        label="대체휴일"
        v-model="replacePeriod"
        readonly
      ></v-text-field>
      <v-text-field
        class="bottom--box"
        label="평일 대체 근무일자"
        v-model="replaceYmd"
        readonly
      ></v-text-field>
      <div v-show="vShowReplace">
        <v-text-field
          class="bottom--box"
          label="시업시간(평일)"
          v-model="replaceTime"
          readonly
        ></v-text-field>
        <v-text-field v-show="replaceShow"
          class="bottom--box"
          label="추가휴게(평일)"
          v-model="replaceAddRestTime"
          readonly
        ></v-text-field>
        <v-text-field v-show="replaceShow"
          class="bottom--box"
          label="대체 근무시간"
          v-model="replaceHm"
          readonly
        ></v-text-field>
        <v-text-field
          class="bottom--box"
          label="취소사유"
          v-model="reqReason"
        ></v-text-field>
      </div>
    </div>
    <v-bottom-navigation fixed scroll-threshold="500" height="96">
      <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
        <v-col cols="12">
          <v-btn
            block
            elevation="0"
            class="btn-fixed btn-blue"
            @click="applovalPage"
          >
            <span class="white--text">다음</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-bottom-navigation>
  </div>
</template>

<script>
import IconApprovalDoc from '@/assets/customIcon/IconApprovalDoc.vue'; // icon svg
import { mapGetters, mapMutations } from 'vuex';
import {
  getHolReplaceAppDetDupCnt,
  getHolReplaceDetail,
  getHolReplaceAppDetHoliChk,
} from '@/api/workStatus';
import dialogMixin from '@/mixins/dialogMixin.js'; // ** dialog Mixin **
import dayjs from 'dayjs';
import routerNames from '@/const/routerConstants';
//import PopupHeader from '@/components/common/PopupHeader.vue';

export default {
  mixins: [dialogMixin],
  data: () => ({
    modalName: 'hol_replace_cancel_view',
    replaceYmd: '',
    workYmd: '',
    workOrgCd: '',
    workOrgNm: '',
    replacePeriod: '',
    note: '',
    bfTimeCd: '',
    bfTimeNm: '',
    startDate: '',
    endDate: '',
    vShow: true,
    vShowReplace: true,
    timeCdList: [],
    restTimeCdList: [],
    flagTimeCd: false,
    flagRestTime: false,
    replaceFlagTimeCd: false,
    replaceFlagRestTime: false,
    reqHm: '',
    reqSHm: '',
    reqEHm: '',
    reqTimeCd: '',
    reqTime: '',
    addRestTimeCd: '',
    restTime: '',
    addRestTime: '',
    replaceReqHm: '',
    replaceReqSHm: '',
    replaceReqEHm: '',
    replaceReqTimeCd: '',
    replaceReqTime: '',
    replaceAddRestTimeCd: '',
    replaceRestTime: '',
    replaceAddRestTime: '',
    selecttitle1: '근무시간',
    selecttitle2: '추가휴게',
    applGubun: '',
    replaceGubun: '',
    workYmdSave: '',
    replaceBfTimeCd: '',
    reqReason: '',
    replaceTime: '',
    replaceHm: '',
    replaceShow: true,

  }),
  props: {
    appInfoParam: Object,
  },

  computed: {
    ...mapGetters('ELA', [
      'GET_APPL_SEQ_EXIST',
      'GET_REFER_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_UI_INFO',
      'GET_ELA_APPL_PARAM',
      'GET_APPL_USER_LIST',
      'GET_MGR_USER_LIST',
      'GET_VACCINATION_PARAM',
      'GET_S_YMD',
      'GET_E_YMD',
    ]),

    ...mapGetters([
      'GET_USER_DATA',
      'GET_WORK_TYPE_CD',
      'GET_NOTE1',
      'GET_WORK_TYPE_NM',
      'GET_REPLACE_YMD',
      'GET_HOL_REPLACE_DATA',
      'GET_HOL_REPLACE_PERIOD_DATA',
      'GET_WORK_YMD',
      'GET_APPL_SEQ',
      'GET_ORG_APPL_SEQ',
      'GET_PARAMS',
    ]),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },

  methods: {
    ...mapMutations('DIALOG', ['SET_DIALOG_PARAM', 'TOGGLE_MODAL']),

    openModal(modalNm) {
      this.$store.commit('DIALOG/TOGGLE_MODAL', modalNm);
    },

    changeBottom1(levelObj) {
      this.reqTimeCd = levelObj.code;
      this.reqTime = levelObj.codeNm;
      this.reqSHm = levelObj.workShm;
      this.reqEHm = levelObj.workEhm;
      console.dir(levelObj);

      this.reqHm =
        this.reqSHm.substring(0, 2) +
        ':' +
        this.reqSHm.substring(2, 4) +
        ' ~ ' +
        this.reqEHm.substring(0, 2) +
        ':' +
        this.reqEHm.substring(2, 4);

      if (this.addRestTimeCd !== '') {
        this.restChange();
      }

      this.flagTimeCd = false;
    },

    changeBottom2(levelObj) {
      this.addRestTimeCd = levelObj.code;
      this.addRestTime = levelObj.codeNm;

      if (this.addRestTimeCd === '') this.addRestTimeCd = '0';

      let endTime = this.reqEHm;

      let hh = endTime.substring(0, 2);
      let mm = endTime.substring(2, 4);
      let date = new Date(2020, 1, 1, hh, mm);
      let addTime = parseFloat(this.addRestTimeCd, 10);

      let addHh = Math.ceil(addTime);
      let addMm = (addTime - addHh) * 60;
      date.setHours(date.getHours() + addHh);
      date.setMinutes(date.getMinutes() + addMm);

      this.reqHm =
        this.reqSHm.substring(0, 2) +
        ':' +
        this.reqSHm.substring(2, 4) +
        ' ~ ' +
        this.formatTime(
          (date.getHours() < 10 ? '0' : '') +
            date.getHours() +
            (date.getMinutes() < 10 ? '0' : '') +
            date.getMinutes(),
        );

      this.flagRestTime = false;
    },

    restChange() {
      let endTime = this.reqEHm;

      let hh = endTime.substring(0, 2);
      let mm = endTime.substring(2, 4);
      let date = new Date(2020, 1, 1, hh, mm);
      let addTime = parseFloat(this.addRestTimeCd, 10);

      let addHh = Math.ceil(addTime);
      let addMm = (addTime - addHh) * 60;
      date.setHours(date.getHours() + addHh);
      date.setMinutes(date.getMinutes() + addMm);

      this.reqHm =
        this.reqSHm.substring(0, 2) +
        ':' +
        this.reqSHm.substring(2, 4) +
        ' ~ ' +
        this.formatTime(
          (date.getHours() < 10 ? '0' : '') +
            date.getHours() +
            (date.getMinutes() < 10 ? '0' : '') +
            date.getMinutes(),
        );
    },

    replaceChangeBottom1(levelObj) {
      this.replaceReqTimeCd = levelObj.code;
      this.replaceReqTime = levelObj.codeNm;
      this.replaceReqSHm = levelObj.workShm;
      this.replaceReqEHm = levelObj.workEhm;

      this.replaceReqHm =
        this.replaceReqSHm.substring(0, 2) +
        ':' +
        this.replaceReqSHm.substring(2, 4) +
        ' ~ ' +
        this.replaceReqEHm.substring(0, 2) +
        ':' +
        this.replaceReqEHm.substring(2, 4);

      if (this.replaceAddRestTimeCd !== '') {
        this.replaceRestChange();
      }

      this.replaceFlagTimeCd = false;
    },

    replaceChangeBottom2(levelObj) {
      this.replaceAddRestTimeCd = levelObj.code;
      this.replaceAddRestTime = levelObj.codeNm;

      if (this.replaceAddRestTimeCd === '') this.replaceAddRestTimeCd = '0';

      let endTime = this.replaceReqEHm;

      let hh = endTime.substring(0, 2);
      let mm = endTime.substring(2, 4);
      let date = new Date(2020, 1, 1, hh, mm);
      let addTime = parseFloat(this.replaceAddRestTimeCd, 10);

      let addHh = Math.ceil(addTime);
      let addMm = (addTime - addHh) * 60;
      date.setHours(date.getHours() + addHh);
      date.setMinutes(date.getMinutes() + addMm);

      this.replaceReqHm =
        this.replaceReqSHm.substring(0, 2) +
        ':' +
        this.replaceReqSHm.substring(2, 4) +
        ' ~ ' +
        this.formatTime(
          (date.getHours() < 10 ? '0' : '') +
            date.getHours() +
            (date.getMinutes() < 10 ? '0' : '') +
            date.getMinutes(),
        );

      this.replaceFlagRestTime = false;
    },

    replaceRestChange() {
      let endTime = this.replaceReqEHm;

      let hh = endTime.substring(0, 2);
      let mm = endTime.substring(2, 4);
      let date = new Date(2020, 1, 1, hh, mm);
      let addTime = parseFloat(this.replaceAddRestTimeCd, 10);

      let addHh = Math.ceil(addTime);
      let addMm = (addTime - addHh) * 60;
      date.setHours(date.getHours() + addHh);
      date.setMinutes(date.getMinutes() + addMm);

      this.replaceReqHm =
        this.replaceReqSHm.substring(0, 2) +
        ':' +
        this.replaceReqSHm.substring(2, 4) +
        ' ~ ' +
        this.formatTime(
          (date.getHours() < 10 ? '0' : '') +
            date.getHours() +
            (date.getMinutes() < 10 ? '0' : '') +
            date.getMinutes(),
        );
    },

    formatTime(strDate, saper) {
      if (strDate == '' || strDate == null) {
        return '';
      }
      if (saper == '' || saper == null) saper = ':';
      if (strDate.length == 4) {
        return strDate.substring(0, 2) + saper + strDate.substring(2, 4);
      } else if (strDate.length == 6) {
        return (
          strDate.substring(0, 2) +
          saper +
          strDate.substring(2, 4) +
          saper +
          strDate.substring(4, 6)
        );
      }
    },

    async applovalPage() {
      if (this.reqReason.trim() === '') {
        alert('취소사유를 입력해 주세요');
        return;
      }
      //기존 다이얼로그 닫기
      //this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_viewer');

      const dupParam = {
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
      };

      const response = await getHolReplaceAppDetDupCnt(dupParam);

      if (response.data.data !== null) {
        alert(
          '동일한 일자에 신청내역이 있습니다. [' +
            (response.data.data.workCnt > 0
              ? ' 근무일자 중복'
              : ' 대체일자 중복') +
            ']',
        );

        return;
      }

      const params = {
        ssnEnterCd: this.GET_USER_DATA.ssnEnterCd,
        searchApplCd: '311',
        searchApplSabun: this.GET_ELA_APPL_PARAM.searchApplInSabun,
        searchApplSeq: this.GET_ELA_APPL_PARAM.searchApplSeq,
        searchApplYmd: dayjs().format('YYYYMMDD'),
        searchApplName: this.GET_USER_DATA.ssnName,
        authPg: 'A', // A신청, R결제
        pathSeq: '',
        applStatusCd: '31', //수신처리중
        fileSeq: '',
        procExecYn: this.GET_UI_INFO.procExecYn,
        etc01: this.GET_UI_INFO.etc01,
        etc02: this.GET_UI_INFO.etc02,
        etc03: this.GET_UI_INFO.etc03,
        etc04: this.GET_UI_INFO.etc04,
        etc05: this.GET_UI_INFO.etc05,
        sYmd: dayjs().format('YYYYMMDD'),
        bApplSeq: this.GET_APPL_SEQ,
        reqReason: this.reqReason,
      };

      this.GET_ELA_APPL_PARAM.searchApplCd = '311';

      // console.log('params ::: ' + JSON.stringify(params));

      this.$store.commit('SET_AUTHPG', 'A');
      this.$store.commit('SET_PARAMS', params);

      this.$store.dispatch('ELA/SET_HOL_REPLACE_CANCEL_PARAMS', params);
      this.$store.commit('SET_APPL_CD', '311');

      this.$router.push(routerNames.ApprovalLine);
    },
  },

  async mounted() {
    if (this.$route.params.applSeq === undefined) {
      this.$route.params.applSeq = this.GET_ORG_APPL_SEQ;
      this.$route.params.ssnEnterCd = this.GET_USER_DATA.ssnEnterCd;
    } else {
      this.$store.commit('SET_ORG_APPL_SEQ', this.$route.params.applSeq);
    }

    let response = await getHolReplaceDetail(this.$route.params);
    // console.log('response :: ' + JSON.stringify(response));

    this.replaceGubun =
      response.data.data.replaceGubun === 'H' ? '반일' : '종일';

    if (response.data.data.replaceGubun !== 'H') {
      this.replaceShow = false;
    }

    this.workYmd = response.data.data.workYmd;
    this.note = response.data.data.note;
    this.reqTime = response.data.data.reqTime;
    this.addRestTime = response.data.data.addRestTime;

    if (response.data.data.reqSHm === null) {
      response.data.data.reqSHm = '';
    }

    if (response.data.data.reqEHm === null) {
      response.data.data.reqEHm = '';
    }

    this.reqHm =
      response.data.data.reqSHm.slice(0, 2) +
      ':' +
      response.data.data.reqSHm.slice(2) +
      ' ~ ' +
      response.data.data.reqEHm.slice(0, 2) +
      ':' +
      response.data.data.reqEHm.slice(2);

    this.replaceYmd = dayjs(response.data.data.replaceYmd).format('YYYY-MM-DD');
    this.replaceAddRestTime = response.data.data.replaceAddRestTime;
    this.replaceTime = response.data.data.replaceTime;

    if (response.data.data.replaceSHm === null) {
      response.data.data.replaceSHm = '';
    }

    if (response.data.data.replaceEHm === null) {
      response.data.data.replaceEHm = '';
    }

    this.replaceHm =
      response.data.data.replaceSHm.slice(0, 2) +
      ':' +
      response.data.data.replaceSHm.slice(2) +
      ' ~ ' +
      response.data.data.replaceEHm.slice(0, 2) +
      ':' +
      response.data.data.replaceEHm.slice(2);

    const params = {
      gubun: 'W',
      workYmd: this.workYmd.replaceAll('-', ''),
    };

    // 날짜 체크
    response = await getHolReplaceAppDetHoliChk(params);
    /*
    this.replacePeriod =
      response.data.data.startDate + ' ~ ' + response.data.data.endDate;
    */
    this.replacePeriod = response.data.data.startDate.substring(0, 4) + '-' + response.data.data.startDate.substring(4, 6) + '-' + response.data.data.startDate.substring(6, 8)
    + ' ~ ' + response.data.data.endDate.substring(0, 4) + '-' + response.data.data.endDate.substring(4, 6) + '-' + response.data.data.endDate.substring(6, 8);

    this.reqReason = this.GET_PARAMS.reqReason===undefined?'':this.GET_PARAMS.reqReason;


    this.OFF_APP_SPINNER();
  },

  setShow() {},

  components: {
    IconApprovalDoc,
    //PopupHeader,
  },
};
</script>

<style>
/* _approval.scss 에 넣음 */
/* dialog */
/* .v-dialog:not(.v-bottom-sheet) {
  background-color: white;
  height: inherit;
} */
</style>
